import React from 'react';
import {Modal} from "antd";
import 'antd/lib/modal/style/css';
import {connect} from "react-redux";
import language from "../../languages/language";
import modalDismiss from "../../actions/modalDismiss";
import getWorkflowDetailsInformation from "../../actions/getWorkflowDetailsInformation";

class WorkflowModal extends React.Component {

    componentDidMount()
    {
        this.props.getWorkflowDetailsInformation({uid:this.props.uid},this.props.modalDismiss);
    }

    render() {
    return (
        <Modal visible={this.props.modalType !== null} width={'70%'} {...this.props.modalProps}>
            <p>
                <div style={{width:'100%'}} className={'ant-table-wrapper'}>
                    <div className={'ant-table-content'}>
                        <table style={{tableLayout:'auto',width:'100%'}}>
                            <colgroup/>
                            <thead className={'ant-table-thead'}><tr>
                                <th style={{textAlign:'center'}} className={'ant-table-cell mobile-show'}>{language[this.props.language].advUserLabel}</th>
                                <th style={{textAlign:'center'}} className={'ant-table-cell mobile-hide'}>{language[this.props.language].advSignDateLabel}</th>
                                <th style={{textAlign:'center'}} className={'ant-table-cell mobile-show'}>{language[this.props.language].advStatusLabel}</th>
                                <th style={{textAlign:'center'}} className={'ant-table-cell mobile-hide'}>{language[this.props.language].advDetailLabel}</th>
                            </tr></thead>
                            <tbody>
                            {this.props.workflowList.pendingSigners && this.props.workflowList.pendingSigners.length>0?this.props.workflowList.pendingSigners.map(
                                (pendingSigner)=>
                                {
                                    return <tr><td style={{textAlign:'center'}} className={'ant-table-cell mobile-show'}>{pendingSigner.signer}</td>
                                        <td style={{textAlign: 'center'}} className={'ant-table-cell mobile-show'}/>
                                        <td style={{textAlign:'center'}} className={'ant-table-cell mobile-show'}>{language[this.props.language].advPendingLabel}</td>
                                    </tr>;
                                }):''}
                            {this.props.workflowList.finishedSigners && this.props.workflowList.finishedSigners.length>0?this.props.workflowList.finishedSigners.map(
                                (finishedSigner)=>
                                {
                                    return <tr><td style={{textAlign:'center'}} className={'ant-table-cell mobile-show'}>{finishedSigner.userName}</td>
                                        <td style={{textAlign:'center'}} className={'ant-table-cell mobile-hide'}>{finishedSigner.fecha}</td>
                                        <td style={{textAlign:'center'}} className={'ant-table-cell mobile-show'}>{language[this.props.language].advSignedLabel}</td>
                                        <td style={{textAlign:'center'}} className={'ant-table-cell mobile-hide'}>{finishedSigner.detail}</td></tr>;
                                }):''}
                            </tbody>
                        </table>
                    </div>
                </div>
            </p>
        </Modal>
    );
  }
}
const mapStateToProps = state => {
     return {
      language: state.auth.language,
      workflowList: state.info.workflowDetails
  };
};

export default connect(mapStateToProps, {modalDismiss,getWorkflowDetailsInformation})(WorkflowModal);
